import { render, staticRenderFns } from "./CoozzyMultiselectHtmlOption.vue?vue&type=template&id=faf99e5e&scoped=true"
import script from "./CoozzyMultiselectHtmlOption.vue?vue&type=script&lang=js"
export * from "./CoozzyMultiselectHtmlOption.vue?vue&type=script&lang=js"
import style0 from "./CoozzyMultiselectHtmlOption.vue?vue&type=style&index=0&id=faf99e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf99e5e",
  null
  
)

export default component.exports